<template>
  <form :id='formId + formIdGuid'>
    <div class='h-col-inputBox h-track-minHeight-55' :class='[data.colspan === true ? "col-sm-12" : tabColClassObject]'
         v-for='(data, index) in formParam.param' :style='(data.type === "formText" && data.colspan === true && data.multiline !== true) ? "padding-right: calc(50% + 50px);": ""'
         :key='index' v-show='(JSON.stringify(defaultData) !== "{}" && data.name==="cellsId") ? true : data.display'>
      <div class='h-inputLit'><span v-if='JSON.stringify(defaultData) === "{}" && data.redFlag === true' class="h-red-code">* </span>{{data.showName}}:</div>
      <component :is='data.type' :data='data' :defaultData='defaultData' @validateUpdate='validateUpdate'></component>
    </div>
  </form>
</template>
<script>
import { FormValidator } from '@syncfusion/ej2-vue-inputs';
import formText from '../formItem/FormText';
import formTime from '../formItem/FormTime';
import formSelect from '../formItem/FormSelect';
import formCheckBox from '../formItem/FormCheckBox';
import { EventBus } from '../../../../plugins/eventBus'

export default {
  name: 'ParseForm',
  components: {
    formText,
    formSelect,
    formTime,
    formCheckBox
  },
  props: {
    formParam: {
      type: Object,
      default() {
        return {
          name: ''
        };
      }
    },
    defaultData: {
      type: Object,
      default() {
        return {};
      }
    },
    formId: {
      type: String,
      default: ''
    },
    cellFlag: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      formIdGuid: this.guid(),
      options: {
        customPlacement: (inputElement, errorElement) => {
          errorElement.style.position = 'fixed';
          if (inputElement && inputElement.parentElement && inputElement.parentElement.parentElement) {
            inputElement.parentElement.parentElement.appendChild(errorElement);
          }
        },
        rules: {}
      },
      validateObj: {}
    };
  },
  computed: {
    tabColClassObject() {
      return this.cellFlag ? 'col-sm-12' : 'col-sm-6';
    }
  },
  methods: {
    guid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : ((r & 0x3) | 0x8);
        return v.toString(16);
      });
    },
    validateUpdate(nameArr, type) {
      this.formParam.param.forEach(item => {
        if (nameArr.includes(item.name) && item.validate && item.validate != null) {
          if (type == 'add') {
            this.validateObj.addRules(item.name, item.validate);
          } else {
            this.validateObj.removeRules(item.name);
          }
        }
      });
    },
    validateResult() {
      let validateRus = true;
      const startValue = this.formParam.param[this.formParam.param.findIndex(v => v.name === 'startTime')].value;
      const endValue = this.formParam.param[this.formParam.param.findIndex(v => v.name === 'endTime')].value;
      if (new Date(startValue).getTime() > new Date(endValue).getTime()) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Track.endTimeGreaterThanStartTime')});
        validateRus = false;
      }
      return this.validateObj.validate() && validateRus;
    }
  },
  mounted() {
    this.validateObj = new FormValidator(`#${this.formId}${this.formIdGuid}`, this.options);
    if (this.formParam.param) {
      this.formParam.param.forEach(item => {
        if (item.validate && item.validate != null) {
          this.validateObj.addRules(item.name, item.validate);
        }
      });
    }
  }
};
</script>
